import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ACCOUNTS_FOR_REVIEW = gql`
  query fetchAccountsForReview($input: FetchAccountsInput!) {
    fetchAccounts(input: $input) {
      accounts {
        id: stringId
        state
        type
        translatedNickName { ${TRANSLATED_STRING_FIELDS} }
        custodianConnection {
          name
        }
        repCode {
          name
        }
        affiliations {
          type
          relation
          user {
            firstName
            middleName
            lastName
          }
        }
        subAccounts {
          id
          goal {
            id
            name
            type
          }
        }
        customFields {
          key
          value
          customField {
            type
            selectOptions {
              displayText { ${TRANSLATED_STRING_FIELDS} }
              value
            }
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      }
    }
  }
`;

export const ARCHIVE_GOAL = gql`
  mutation archiveGoal($input: ArchiveGoalInput!) {
    archiveGoal(input: $input) {
      goal {
        id
      }
    }
  }
`;
